import { useState } from "react";
import PropTypes from "prop-types";
import { t } from "@/i18n-js/instance";
import { Modal } from "@/react/components/shared/uikit/ModalV2";
import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { Content } from "../../ChatSpace/RailBar/Content";
import { useChatSpaceMembers } from "../../ChatSpace/RailBar/hooks/useChatSpaceMembers";

export const ChatSpaceDropdownActions = ({ space }) => {
  const { spaceMembers, has_more_space_members, refetchSpaceMembers } =
    useChatSpaceMembers();

  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  const onShowDetailsClick = () => {
    setIsDetailsModalOpen(true);
  };

  const onModalClose = () => {
    setIsDetailsModalOpen(false);
  };

  const { chat_room_description: description } = space;

  return (
    <>
      <Dropdown.ItemLink onClick={onShowDetailsClick}>
        {t("chat_space.details")}
      </Dropdown.ItemLink>
      <Modal isOpen={isDetailsModalOpen} onClose={onModalClose}>
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header>
            <Modal.Title>{t("chat_space.details")}</Modal.Title>
            <Modal.HeaderActions>
              <Modal.CloseButton onClick={onModalClose} />
            </Modal.HeaderActions>
          </Modal.Header>
          <Modal.Body className="flex flex-col gap-4">
            {description && (
              <Typography.BodySm>{description}</Typography.BodySm>
            )}
            <Content
              spaceMembers={spaceMembers}
              hasMoreSpaceMembers={has_more_space_members}
              space={space}
              refetchSpaceMembers={refetchSpaceMembers}
            />
          </Modal.Body>
        </Modal.Content>
      </Modal>
    </>
  );
};

ChatSpaceDropdownActions.propTypes = {
  space: PropTypes.object.isRequired,
};
